import { Button, DatePicker, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import EmptyContent from '../../../components/EmptyContent'
import {
  DATE_FORMAT_DEFAULT,
  ELECTRONIC_DOCUMENT_STATUS,
  ISO_DATE_FORMAT,
} from '../../../constants'

const { RangePicker } = DatePicker
const { Option } = Select

const STATUS_MAPPING = {
  [ELECTRONIC_DOCUMENT_STATUS.PENDING]: 'Chưa xử lý',
  [ELECTRONIC_DOCUMENT_STATUS.CRE_APPROVAL]: 'Đã trình dự thảo',
  [ELECTRONIC_DOCUMENT_STATUS.KTAT_OFFICE_APPROVAL]: 'P.KTAT đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.KTAT_OFFICE_REJECTION]: 'P.KTAT hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL]: 'Trưởng đơn vị đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_REJECTION]: 'Trưởng đơn vị hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_KTAT_OFFICE_APPROVAL]: 'TP.KTAT đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.LEAD_KTAT_OFFICE_REJECTION]: 'TP.KTAT hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.BOARD_OF_DIRECTOR_APPROVAL]:
    'Ban Giám đốc đã duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.BOARD_OF_DIRECTOR_REJECTION]:
    'Ban Giám đốc hủy duyệt',
  [ELECTRONIC_DOCUMENT_STATUS.ROLLBACK_TO_CREATOR]:
    'Từ chối — Trả về Người lập',
  [ELECTRONIC_DOCUMENT_STATUS.ROLLBACK_TO_LEADER]:
    'Từ chối — Trả về Trưởng đơn vị',
  [ELECTRONIC_DOCUMENT_STATUS.FLOW_LOCKED]: 'Đã khóa luồng trình ký',
  [ELECTRONIC_DOCUMENT_STATUS.FLOW_UNLOCK]: 'Đã mở lại luồng trình ký',
  [ELECTRONIC_DOCUMENT_STATUS.READY]: 'Chờ phát hành',
  [ELECTRONIC_DOCUMENT_STATUS.READY_REJECTION]: 'Đóng dấu lại',
  [ELECTRONIC_DOCUMENT_STATUS.RELEASE]: 'Đã phát hành',
}

const AdvanceFilterBlock = props => {
  const { electronicDocumentStore, onClose } = props
  const { queryParamsSignDocument } = electronicDocumentStore

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search)
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({
      status: queryStringParse.status || undefined,
      dateRange:
        queryStringParse.from_date && queryStringParse.to_date
          ? [moment(queryStringParse.from_date), moment(queryStringParse.to_date)]
          : undefined,
    })
  }, [queryStringParse, form])

  const onFinish = values => {
    const { status, dateRange } = values
    const from_date = dateRange ? moment(dateRange[0]).format(ISO_DATE_FORMAT) : null
    const to_date = dateRange ? moment(dateRange[1]).format(ISO_DATE_FORMAT) : null

    electronicDocumentStore.setQueryParamsSignDocument({
      ...queryParamsSignDocument,
      page: 0,
      status: status || null,
      from_date,
      to_date,
    })

    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: 0,
        size: 10,
        status: status || null,
        from_date,
        to_date,
      },
      { skipNull: true }
    )
    history.replace(`/archiving-n-distribution?${queryStringStringify}`)
    if (onClose) onClose()
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}
      className="advance-filter-form"
    >
      <style>{`
        .advance-filter-form .ant-form-item {
          margin-bottom: 16px;
        }
        .advance-filter-form .ant-form-item-label > label {
          color: #333;
        }
        .advance-filter-form .ant-input,
        .advance-filter-form .ant-input-affix-wrapper,
        .advance-filter-form .ant-picker,
        .advance-filter-form .ant-select-selector {
          border-radius: 8px !important;
        }
      `}</style>
      


      <Form.Item label="Trạng thái" name="status">
        <Select
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          notFoundContent={<EmptyContent />}
          optionFilterProp={'name'}
          placeholder={'Chọn trạng thái'}
        >
          {Object.keys(STATUS_MAPPING).map(statusKey => (
            <Option key={statusKey} value={statusKey} name={statusKey}>
              {STATUS_MAPPING[statusKey]}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Ngày trình" name="dateRange">
        <RangePicker
          style={{ width: '100%' }}
          placeholder={['Từ ngày', 'Đến ngày']}
          format={DATE_FORMAT_DEFAULT}
        />
      </Form.Item>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 24, marginBottom: 8 }}>
        <Button onClick={onClose} style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Huỷ
        </Button>
        <Button type="primary" htmlType="submit" style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Áp dụng
        </Button>
      </div>
    </Form>
  )
}

AdvanceFilterBlock.propTypes = {}

export default inject('electronicDocumentStore')(observer(AdvanceFilterBlock))
